export default __webpack_public_path__ + "static/media/eligibility.bbd36fbb.svg";